module.exports = __webpack_public_path__ + "media/images/pages/img_cover_right_12-5a794a13daa415678d49d638a1e36d2b.jpg";